import { render, staticRenderFns } from "./SwiperCore.vue?vue&type=template&id=59c87521&scoped=true"
import script from "./SwiperCore.vue?vue&type=script&setup=true&lang=js"
export * from "./SwiperCore.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SwiperCore.vue?vue&type=style&index=0&id=59c87521&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c87521",
  null
  
)

export default component.exports